import React, { Component } from "react";
import Constants from "../../../utils/constants";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  companyTable: {
    borderCollapse: "collapse",
    marginBottom: "14pt",
    width: "100%",
  },
  companyHeader: {
    borderBottom: "1px solid #000000",
    fontSize: "12pt",
    padding: "4pt",
    textAlign: "left",
  },
  companyCell: {
    padding: "2pt 4pt",
    verticalAlign: "top",
  },
  companyCellRight: {
    padding: "2pt 4pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  informationBlock: {
    marginBottom: "12pt",
  },
  paragraph: {
    margin: "2pt 0",
  },
  sectionTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "10pt",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #000000",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #000000",
    padding: "3pt",
    verticalAlign: "top",
  },
  photoCell: {
    border: "1px solid #000000",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "top",
  },
  photo: {
    height: "auto",
    maxWidth: "100%",
  },
};

export default class DescriptifPDF extends Component {
  render() {
    const { lot, pieces } = this.props;

    let chemin = "";

    return (
      <div style={styles.document}>
        <table style={styles.companyTable}>
          <thead>
            <tr>
              <th colSpan="2" style={styles.companyHeader}>
                <strong>{lot.lot_societe.societe_raison_sociale}</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td width="50%" style={styles.companyCell}>
                {lot.lot_societe.societe_adresse.adresse_numero}{" "}
                {lot.lot_societe.societe_adresse.adresse_voie}
              </td>
              <td width="50%" style={styles.companyCellRight}>
                Tél : {lot.lot_societe.societe_telephone}
              </td>
            </tr>
            <tr>
              <td width="50%" style={styles.companyCell}>
                {lot.lot_societe.societe_adresse.adresse_code_postal}{" "}
                {lot.lot_societe.societe_adresse.adresse_ville}
              </td>
              <td width="50%" style={styles.companyCellRight}>
                E-mail : {lot.lot_societe.societe_email}
              </td>
            </tr>
          </tbody>
        </table>
        <div style={styles.informationBlock}>
          <p style={styles.paragraph}>
            <strong>
              {lot.lot_reference}
              {" - "}
              {lot.lot_designation}
            </strong>
          </p>
          <p style={styles.paragraph}>
            {lot.lot_adresse.adresse_numero} {lot.lot_adresse.adresse_voie}
          </p>
          <p style={styles.paragraph}>
            {lot.lot_adresse.adresse_code_postal} {lot.lot_adresse.adresse_ville}
          </p>
        </div>
        <div style={styles.informationBlock}>
          <p style={styles.paragraph}>
            <strong>DESCRITPIF</strong>
          </p>
          <p style={styles.paragraph}>
            {"Nombre de couchages : "}
            {lot.lot_couchage}
          </p>
          <p style={styles.paragraph}>
            {"Nombre de pièces : "}
            {lot.lot_nb_pieces}
          </p>
          <p style={styles.paragraph}>
            {"Surface totale : "}
            {lot.lot_surface}
            {" m²"}
          </p>
          <p style={styles.paragraph}>
            {"Nombre de niveaux : "}
            {lot.lot_niveau}
          </p>
          <p style={styles.paragraph}>
            {"Nombre de chambres : "}
            {"à calculer"}
          </p>
        </div>
        <div>
          <table style={styles.sectionTable}>
            <thead>
              <tr>
                <th width="100%" scope="col" style={styles.sectionHeader}>
                  <strong>EQUIPEMENTS</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {lot.lot_equipements.map((equipement, i) => {
                return (
                  <tr key={i}>
                    <td width="100%" style={styles.cell}>
                      {equipement.equipement_libelle}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div>
          <table style={styles.sectionTable}>
            <thead>
              <tr>
                <th width="100%" scope="col" style={styles.sectionHeader}>
                  <strong>PIECES</strong>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        {pieces.map((piece, i) => {
          return (
            <div key={i}>
              <table style={styles.sectionTable}>
                <thead>
                  <tr>
                    <th width="100%" scope="col" style={styles.sectionHeader}>
                      <strong>{piece.piece_libelle}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {piece.piece_contenu.map((contenu, j) => {
                    if (contenu.piece_contenu_champ_perso.champ_perso_groupe_type === 4) {
                      if (contenu.piece_contenu_champ_perso.champ_perso_type === 1) {
                        if (
                          contenu.piece_contenu_valeur === "true" ||
                          contenu.piece_contenu_valeur === "1"
                        ) {
                          return (
                            <tr key={j}>
                              <td width="100%" style={styles.cell}>
                                {contenu.piece_contenu_champ_perso.champ_perso_libelle}
                              </td>
                            </tr>
                          );
                        }
                      }
                      if (
                        contenu.piece_contenu_champ_perso.champ_perso_type === 2 ||
                        contenu.piece_contenu_champ_perso.champ_perso_type === 3
                      ) {
                        if (contenu.piece_contenu_valeur !== "") {
                          return (
                            <tr key={j}>
                              <td width="100%" style={styles.cell}>
                                {contenu.piece_contenu_champ_perso.champ_perso_libelle}{" "}
                                {contenu.piece_contenu_valeur}
                              </td>
                            </tr>
                          );
                        }
                      }
                    }
                    return null;
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
        <div>
          <table style={styles.sectionTable}>
            <thead>
              <tr>
                <th width="100%" scope="col" style={styles.sectionHeader}>
                  <strong>ELEMENTS</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {lot.lot_elements.map((element, i) => {
                if (element.lot_champ_perso_champ_perso.champ_perso_groupe_type === 3) {
                  if (element.lot_champ_perso_champ_perso.champ_perso_type === 1) {
                    if (element.lot_champ_perso_valeur === "true") {
                      return (
                        <tr key={i}>
                          <td width="100%" style={styles.cell}>
                            {element.lot_champ_perso_champ_perso.champ_perso_libelle}
                          </td>
                        </tr>
                      );
                    }
                  }
                  if (
                    element.lot_champ_perso_champ_perso.champ_perso_type === 2 ||
                    element.lot_champ_perso_champ_perso.champ_perso_type === 3
                  ) {
                    if (element.lot_champ_perso_valeur !== "") {
                      return (
                        <tr key={i}>
                          <td width="100%" style={styles.cell}>
                            {element.lot_champ_perso_champ_perso.champ_perso_libelle}{" "}
                            {element.lot_champ_perso_valeur}
                          </td>
                        </tr>
                      );
                    }
                  }
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
        <div>
          <table style={styles.sectionTable}>
            <thead>
              <tr>
                <th width="100%" scope="col" style={styles.sectionHeader}>
                  <strong>DESCRIPTIF</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {lot.lot_descriptions.map((desc, i) => {
                if (i === 0) {
                  return (
                    <tr key={i}>
                      <td width="100%" style={styles.cell}>
                        {desc.description_titre}
                        <br />
                        {desc.description_html}
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
        <div>
          <table style={styles.sectionTable}>
            <thead>
              <tr>
                <th width="100%" scope="col" style={styles.sectionHeader}>
                  <strong>PHOTOS</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {lot.lot_photos.map((photo, i) => {
                if (photo.photo_edition) {
                  chemin = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/photos/display/${photo.photo_id}`;
                  return (
                    <tr key={i}>
                      <td width="100%" style={styles.photoCell}>
                        <img src={chemin} alt="" style={styles.photo} />
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
